import React, { useState } from 'react';

import { IconTypes } from '@eika/icon';

import { SigningContextProvider } from '@/domain/signing';
import piwik from '@/piwik/piwik';

import { CreditCardPanelItem, CreditCardService } from '@domain/card';
import { CreditCard, CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

import { CardPaymentModal } from './CardPaymentModal';

type CardPaymentProps = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const CardPayment = ({ card, account }: CardPaymentProps) => {
    const [open, setOpen] = useState(false);
    const isOwner = CreditCardService.isOwnerOfCard(card);
    const text = useText();

    return (
        <>
            <CreditCardPanelItem
                hide={!card.allowedOperations.canTransfer || !isOwner}
                iconType={IconTypes.LOMMEBOK_24}
                piwikTag={piwik.transfer.paymentButton}
                title={text.paymentTitleKredittbanken}
                onClick={() => setOpen(true)}
                id="button-payment"
            />
            {open && (
                <SigningContextProvider>
                    <CardPaymentModal setOpenModal={setOpen} card={card} account={account} />
                </SigningContextProvider>
            )}
        </>
    );
};
